import { Component, OnInit, forwardRef } from '@angular/core';
import {
  NavController,
  NavParams,
  LoadingController,
  ModalController,
  IonicModule,
} from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { HistoricoPage } from '../historico/historico.page';
import { MdaProvider } from 'src/app/services/mda/mda';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from 'src/app/pipes/date-format/date-format';
import { LoadingSpinnerComponent } from 'src/app/components/loading/loading-spinner/loading-spinner.component';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-historico-lista',
  templateUrl: './historico-lista.page.html',
  styleUrls: ['./historico-lista.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    LoadingSpinnerComponent,
    SemRegistroComponent,
  ],
})
export class HistoricoListaPage implements OnInit {
  id: string = '';
  historicos: any = [];
  loaded = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public modalCtrl: ModalController,
    private translate: TranslateService
  ) {
    this.id = navParams.get('idMda');
    this.mdaProvider.getHistoricos(this.id).subscribe((data) => {
      this.historicos = data;

      setTimeout(() => {
        this.loaded = true;
      }, 1000);
    });
  }

  ngOnInit() {}

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async addHistorico() {
    var data = { idMda: this.id, idMdaEncontro: false };
    const modalPage = await this.modalCtrl.create({
      component: HistoricoPage,
      componentProps: data,
    });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    this.mdaProvider.getHistoricos(this.id).subscribe((data) => {
      this.historicos = data;
    });
  }
}
